import Http from "./http";

export const claimReminderTemplatesListAPI = (data) => {
  return Http.post(`admin/email-templates/getClaimReminderTemplates`,data);
};
